import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SupportAgent from '@mui/icons-material/SupportAgent';
import AutoGraph from '@mui/icons-material/AutoGraph';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import PersonAdd from '@mui/icons-material/PersonAdd';
import MobileFriendly from '@mui/icons-material/MobileFriendly';
import Create from '@mui/icons-material/Create';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

const items = [
  {
    icon: <PersonAdd />,
    title: 'Great User Experience / User Friendly',
    description:
      'Easy navigation and intuitive design, making it simple for both doctors, actors, and examiners to use.'
  },
  {
    icon: <AutoGraph />,
    title: 'Tracking System',
    description:
      'Keep track of which cases you’ve completed and see which ones need more improvement, ensuring focused preparation.'
  },
  {
    icon: <Create />,
    title: 'New Cases Added Regularly',
    description:
      'We’re constantly adding new, real-life modeled cases to our library, so you always have fresh content to practice with.'
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Innovative functionality',
    description:
      'Stay ahead with features that set new standards, addressing your evolving needs better than the rest.'
  },
  {
    icon: <MobileFriendly />,
    title: 'Mobile, Tablet, and PC Compatible',
    description: `Access the site from any device—whether you're on the go or at your desk, our website is designed to work seamlessly across mobile, tablet, and PC.`
  },
  {
    icon: <SupportAgent />,
    title: 'Reliable Customer Support',
    description:
      'Our support team is always ready to assist, ensuring you have a smooth experience and can get help whenever needed.'
  }
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: '#06090a'
      }}>
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 }
        }}>
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' }
          }}>
          <Typography component="h2" variant="h4">
            Highlights
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
            Explore why our product stands out.
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                color="inherit"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  p: 3,
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'grey.800',
                  background: 'transparent',
                  backgroundColor: 'grey.900'
                }}>
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography fontWeight="medium" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
